export const FETCH_NOTIFICATION_LIST = "FETCH_NOTIFICATION_LIST";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
